import Vue from 'vue';
import dropWrapper from '@/components/global/drop-wrapper/index.vue';
import apiKeysBody from '@/components/pages/apiKeysPage/index.vue';
import translation from '@/assets/rawData/i18n/apiKeysPage.json';
import applyPageI18NMessages from '@/vue-utils/i18n';
export default Vue.extend({
    name: 'apiKeysPage',
    components: {
        dropWrapper,
        apiKeysBody
    },
    created() {
        applyPageI18NMessages(this, 'apiKeysPage', translation);
    }
});
